module.exports = __webpack_public_path__ + "img/TechGatherWood1_ua.dec58367.webp";